export default "/assets/website/images/astronaut.png?7f6121291190ec685241f86aff2a10e4";